/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthenticationStrictHttpResponse } from '../../authentication-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VerifyOtpRequestModel } from '../../models/verify-otp-request-model';

export interface LocalAccountVerifyOtpAsyncPost$Params {
  
    /**
     * OTP verification model containing email and OTP code
     */
    body?: VerifyOtpRequestModel
}

export function localAccountVerifyOtpAsyncPost(http: HttpClient, rootUrl: string, params?: LocalAccountVerifyOtpAsyncPost$Params, context?: HttpContext): Observable<AuthenticationStrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, localAccountVerifyOtpAsyncPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as AuthenticationStrictHttpResponse<boolean>;
    })
  );
}

localAccountVerifyOtpAsyncPost.PATH = '/LocalAccount/VerifyOTPAsync';
